module.exports = __webpack_public_path__ + "static/img/xhwb_jcx.1959c8b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/xhwb_jcx.png
// module id = aqxn
// module chunks = 0